import React from "react";

const AppLayoutWrapper = ({ children }) => {
  return (
    <div className="l-inner">
      <section className="l-page">{children}</section>
    </div>
  );
};

export default AppLayoutWrapper;
